module.exports = __webpack_public_path__ + "img/concentration_5.9c236fbd.svg";